import { render, staticRenderFns } from "./BeforeFooterComponent.vue?vue&type=template&id=e89e7c4a&scoped=true&"
import script from "./BeforeFooterComponent.vue?vue&type=script&lang=js&"
export * from "./BeforeFooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./BeforeFooterComponent.vue?vue&type=style&index=0&id=e89e7c4a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89e7c4a",
  null
  
)

export default component.exports